import * as api from '../utils/api';

// `prices` is null until loaded, then an id -> route map keyed by `${departurePlaceId}-${arrivalPlaceId}`.
// Backend recomputes the priced routes nightly; we refresh at most once per TTL and keep them in state,
// serving stale data while a refresh is in flight (stale-while-revalidate).
const TTL = 2 * 60 * 60 * 1000; // 2 hours

const initialState = {
  prices: null,
  lastFetched: 0,
};

const SET_ROUTE_PRICES = 'SET_ROUTE_PRICES';

// Dedupes concurrent loads, mirroring catalog's `isFetchingProducts` guard.
let isFetchingRoutePrices = undefined;

export const loadRoutePrices = () => async (dispatch, getState) => {
  const { prices, lastFetched } = getState().routePrices;
  if (prices && Date.now() - lastFetched < TTL) {
    return;
  }
  if (isFetchingRoutePrices) {
    return isFetchingRoutePrices;
  }

  isFetchingRoutePrices = (async () => {
    try {
      const routes = await api.getRoutePrices();
      dispatch({
        type: SET_ROUTE_PRICES,
        prices: Object.fromEntries(routes.map((route) => [route.id, route])),
        lastFetched: Date.now(),
      });
    } catch (error) {
      console.warn('Failed to load route prices:', error);
      // Keep showing stale prices on a failed refresh; only blank on the very first load.
      if (!getState().routePrices.prices) {
        dispatch({ type: SET_ROUTE_PRICES, prices: {}, lastFetched: Date.now() });
      }
    } finally {
      isFetchingRoutePrices = null;
    }
  })();

  return isFetchingRoutePrices;
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ROUTE_PRICES:
      return { ...state, prices: action.prices, lastFetched: action.lastFetched };
    default:
      return state;
  }
};
